<template>
  <div class="shangquanmaidanPage">
    <div class="xr-mingxi">        
        <mu-appbar class="xr-head" :title="storeInfo.CompanyName">
            <mu-icon-button v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>
             <mu-icon value=":fa fa-xinxi"  slot="right"/>
        </mu-appbar>
    </div>
    <div class="logo">
         <mu-avatar :src="storeInfo.Logo" slot="leftAvatar" :size="100"/>
         <p style="font-size: 16px;">{{storeInfo.CompanyName}}</p>
    </div>
    <mu-col width="100" tablet="100" desktop="100" class="rowFiled conunt">
        <mu-text-field hintText="询问服务员后输入" labelFloat label="消费总额:" type="number" v-model="totalMoney" fullWidth></mu-text-field>
    </mu-col>
    <mu-col width="100" tablet="100" desktop="100" class="rowFiled" v-if="storeInfo.IsDiscount == 1">
        <mu-text-field hintText="根据折扣计算实际消费金额" labelFloat label="优惠后金额:" v-model="payMoney" disabled fullWidth></mu-text-field>
    </mu-col>
    <mu-list-item  class="proList" v-if="storeInfo.IsDiscount==1">
      <div class="temai">
          <img  src=" ../static/shangquan/付.png" alt="">
          <span style="padding-left: 13px; height:20px;font-size: 18px;">全部商品享{{storeInfo.SaleDiscount}}折</span>
      </div>
    </mu-list-item>
    <mu-col width="100" tablet="100" desktop="100" class="rowFiled" v-if="storeInfo.IsDiscount == 2">
        <mu-text-field :hintText="'请输入' + candyCname + '金额'" labelFloat :label="candyCname + '金额:'" v-model="bawMoney" fullWidth></mu-text-field>
    </mu-col>
    <mu-row class="gutter">
        <mu-col width="100" tablet="50" desktop="33" class="btn-div">          
            <mu-raised-button label="确认买单" class="submit"  fullWidth @click="submitOrder()" />
        </mu-col>
    </mu-row>
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>
<script>
export default {
  data() {
    return {
      proItemInfoWidth: (parseInt(document.documentElement.clientWidth)-135),
      show:false,
      storeInfo:{
        CompanyName:''
      },
      totalMoney : '',
      payMoney: '',
      bawMoney : ''
    }
  },
  mounted() {
    this.getStoreInfo()
  },
  methods: {
    GoHistory(){
      this.$router.goBack()
    },
    getStoreInfo(){      
      const ths = this;
      this.$post("/Shop/StoreServer/GetShopsPhysicalStore", {'shopId':this.$route.query.shopId})
      .then(function(res) {
        if (res.IsSuccess) {
          ths.loaded = false;
          
          ths.storeInfo = res.Data

          //ths.$refs.XRtoast.hide();
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    submitOrder(){      
      const ths = this;

      if(!(this.totalMoney>0)){
        ths.$refs.XRtoast.failed('请输入消费金额',true);
        return
      }
      var baw = 0
      if(this.storeInfo.IsDiscount == 2){
        if(!(this.bawMoney>0)){
          ths.$refs.XRtoast.failed('请输入' + this.candyCname + '金额',true);
          return
        }
        baw = this.bawMoney
      }else{
        baw = 0
      }

      this.$post("/Shop/StoreServer/ShopsPhysicalOfflinePay", {'shopId':this.$route.query.shopId,'totalMoney':this.totalMoney , 'bawMoney': baw})
      .then(function(res) {
        if (res.IsSuccess) {
          ths.loaded = false;
          if(res.TypeId == 1){
            ths.$router.push('/shangquan/paySuccess')
          }else{
            ths.$router.push('/shangquan/pay?logNo=' + res.Data)
          }
        }else{
          ths.$refs.XRtoast.failed(res.Msg, true);
          return
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    }
  },
  computed: {
    
  },
  watch:{
    totalMoney(){
      if(this.storeInfo.IsDiscount>0){
        this.payMoney = (this.storeInfo.SaleDiscount/10 * this.totalMoney).toFixed(2)
        //this.payMoney = this.storeInfo.SaleDiscount/10 * this.totalMoney
      }
    }
  }
};
</script>
<style>
body .shangquanmaidanPage{
  background: #fff;
}
.shangquanmaidanPage .xr-mingxi .mu-appbar.fixed{  
  padding:0;
  position: fixed;
  top:0;
  left: 0;
}
.xr-mingxi .xr-head .fa-xing1{
  font-size: 24px;
  width: 28px;
  margin-right: 5px;
  padding-bottom: 5px;
}
.shangquanmaidanPage .xr-mingxi .mu-appbar-title {
    font-size: 16px;
    text-align: center;
    }
.shangquanmaidanPage .xr-mingxi .left .mu-icon-button {
    color:white;
    }
.shangquanmaidanPage .xr-mingxi .title .title-text {
    margin: 0;
    line-height: 48px;
    }
.shangquanmaidanPage .proList{
    border-bottom: 1px solid #f5f5f5;
}
.shangquanmaidanPage .xr-mingxi .right{
    width: 48px;
    font-size: 16px;
    text-align: center;
}
.shangquanmaidanPage .xr-mingxi .right .fa-xinxi{
    width: 48px;
    font-size: 24px;
}
.shangquanmaidanPage .xr-mingxi .right a{
    color: #fff;
}
.shangquanmaidanPage .xr-mingxi .mu-paper-1{
  box-shadow: none;
}
.shangquanmaidanPage .logo{
  height: 25%;
  padding-top: 8%;
  text-align: center;
}
.shangquanmaidanPage .rowFiled{
  padding: 0 5%;
}
.shangquanmaidanPage .conunt{
  margin-top: 80px;
}
.shangquanmaidanPage .conunt .mu-text-field{
  min-height: 5px
}
.shangquanmaidanPage .proList .mu-item .temai{
  display: flex;
  align-items: center;
}
.shangquanmaidanPage .col .mu-text-field-label,.shangquanmaidanPage .col .mu-text-field.has-label .mu-text-field-label.float{
  color: #000;
}
.shangquanmaidanPage .gutter{
  padding: 5%;
  margin-top: 5%;
}
.shangquanmaidanPage .gutter .mu-raised-button{
  background: #7e848c;
  height: 50px;
}
.shangquanmaidanPage .gutter .mu-raised-button .mu-raised-button-label{
  font-size: 14px;
  color: #fff;
}
</style>




// WEBPACK FOOTER //
// src/pages/shangquan/maidan.vue